import { useState } from "react";

const useSummary = () => {
  const [summaryData] = useState([
    {
      icon: "/img/brands.png",
      title: "Products",
      count: "100",
    },
    {
      icon: "/img/employee.png",
      title: "Employees",
      count: "500",
    },
    {
      icon: "/img/farmer.png",
      title: "Happy Farmers",
      count: "500000",
      prefix: ""
    },
    {
      icon: "/img/countries.png",
      title: "Countries",
      count: "8",
    },
    {
      icon: "/img/expertise.png",
      title: "Years of Expertise",
      count: "27",
    },
    {
      icon: "/img/acers_covered_img.png",
      title: "Acres Covered",
      count: "1000000",
      // prefix: "Million",
    },
    {
      icon: "/img/poultry-Icon.png",
      title: "Farms Covered",
      count: "10000",
    },
  ]);

  return {
    summaryData,
  };
};

export default useSummary;
